<template>
  <VRReport v-if="userHasPermission" :useClientLayout="true" />
  <AdminLayout v-else page="VR Report" title="VR Report">
    You need permission to view this page.
  </AdminLayout>
</template>
<script lang="ts" setup>
import VRReport from "../staffadmin/VRReport.vue";
import { PermissionType } from "../../store/generatedFetchClient";
import { useUserStore } from "../../store/userStore";

var userHasPermission = computed(() =>
  useUserStore().hasPermission(PermissionType.ViewVRReport)
);
</script>
